import { getTimestamps, isWeekday } from './time-utils';

import { DepartmentsAndOpeningHours } from '../components/OpeningHours';
import { getGraphAndTexts } from '../config/graph-and-texts';
import { getOpeningHours } from '../config/opening-hours';
import { getNextOpenBusinessDay } from './calculate-opening-hours';

export const getGraphAndTextsAndOpeningHours = (dateTime: Date) => {
    const { dayName, curTime, date, localDayName, localCurTime } = getTimestamps(dateTime);

    const graphAndTexts = getGraphAndTexts(dayName);

    // Iterate *backwards* to find the first item where
    // the current time is larger than the given startTime
    // This way it is possible to have multiple starting times
    // 00.00
    // 12.00
    function getOpeningHoursTitle(localclosedRestOfTheDay: boolean) {
        let openingHoursTitle;
        let openingHoursDate = '';
        if (localclosedRestOfTheDay) {
            let nextOpenDay = getNextOpenBusinessDay(date);
            if (nextOpenDay === 'tomorrow') {
                openingHoursTitle = 'label.opening.hours.title.tomorrow';
            } else if (nextOpenDay === 'mon') {
                openingHoursTitle = 'label.opening.hours.title.onMonday';
            } else {
                openingHoursTitle = 'label.opening.hours.title.openHoursOn';
                openingHoursDate = nextOpenDay;
            }
        } else {
            openingHoursTitle = 'label.opening.hours.title.today';
        }
        return { openingHoursTitle, openingHoursTitleSuffix: openingHoursDate };
    }

    // 18.00
    for (let i = graphAndTexts.length - 1; i >= 0; i--) {
        const r = graphAndTexts[i];

        let { openingHoursTitle, openingHoursTitleSuffix } = getOpeningHoursTitle(r.closedRestOfTheDay);

        let { startTime, graph, graphTitle, graphText, openingHoursKey } = r;
        if (curTime >= startTime) {
            return {
                dayNameInUse: dayName,
                curTimeInUse: curTime,
                localDayName,
                localCurTime,
                graph,
                graphTitle,
                graphText,
                openingHoursTitle,
                openingHoursTitleSuffix,
                departments: addIsOpenToOpeningHours(openingHoursKey, dayName, curTime),
            };
        }
    }

    throw new Error('Could not extract the graphs and texts');
};

/**
 * Adds 'isOpen' with a boolean of whether or not the department is open
 *
 * Notice that the isOpen is *decoupled* from the actually shown opening hours
 * We are closed on Saturdays and Sundays where the *Monday* opening hours are shown
 * Right after the Monday opening hours, we show "Closed" in the weekend
 *
 * @param openingHoursKey The key obtained from configuration
 * @param dayName *Today's* date for calculating the open/closed sign
 * @param curTime *Today's* time for calculating the open/closed sign
 */
const addIsOpenToOpeningHours = (openingHoursKey: string, dayName: any, curTime: number) => {
    if (!isWeekday(openingHoursKey)) {
        throw new Error('Something is seriously wrong with the configuration...I have no clue what to do...');
    }

    const openingHoursToBeShown = getOpeningHours(openingHoursKey);
    const openingHoursToday = getOpeningHours(dayName);

    const data: DepartmentsAndOpeningHours[] = [];
    for (let i = 0; i < openingHoursToBeShown.length; i++) {
        const r = openingHoursToBeShown[i];

        const openTime = openingHoursToday[i].openTime;
        const closeTime = openingHoursToday[i].closeTime;

        const isOpen = openTime !== null && closeTime !== null && curTime >= openTime && curTime < closeTime;

        data.push({ ...r, ...{ isOpen: isOpen } });
    }

    return data;
};
